// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2937":"eabe11fc","5970":"3dbccb2b"}[chunkId] || chunkId) + "." + {"1167":"01d2aefe0f3c9201","2592":"44d8647a1d0e4540","2937":"8549aaeb3e4e6c78","5970":"0f9a36b942175991","9956":"b6c235d9ea0116a6"}[chunkId] + ".js";
};